type StatusType = 'failed' | 'success'
type CallbackFn = (args: {
  status: StatusType
}) => void

/**
 * 装饰器，用于增强 parseProperty 函数
 * @param fn 原始函数
 * @returns 包装后的函数，返回解析结果和状态
 */
const withParseStatus = (fn: (value: unknown, property: string, callback?: CallbackFn) => string) => {
  return (value: unknown, property: string): { result: string; status: StatusType } => {
    let parsedStatus: StatusType = 'success'
    const parsedResult = fn(value, property, ({
      status,
    }) => {
      parsedStatus = status
    })
    return { result: parsedResult, status: parsedStatus }
  }
}

/**
 * 解析指定属性
 * @param value 可能包含属性的值
 * @param property 要提取的属性名
 * @returns 提取出的属性值或默认值
 */
export const parseProperty = (value: unknown, property: string, callback?: CallbackFn): string => {
  if (value === null || value === undefined || value === "") {
    return "--"
  }

  if (typeof value === "object" && value !== null) {
    if (property in value) {
      return String((value as Record<string, unknown>)[property]) || "--"
    } else {
      return "--"
    }
  }

  if (typeof value === "string") {
    try {
      const parsedValue = JSON.parse(value)
      if (typeof parsedValue === "object" && parsedValue !== null) {
        if (property in parsedValue) {
          return String(parsedValue[property]) || "--"
        } else {
          return "--"
        }
      }
    } catch {
      // 如果解析失败，直接返回原始字符串
      if (callback) {
        callback({
          status: 'failed',
        })
      }
      return value
    }
  }

  return String(value) || "--"
}

// 使用装饰器增强 parseProperty
export const parsePropertyWithStatus = withParseStatus(parseProperty)

// 现有的 parseUser 函数可以重用 parseProperty
export const parseUser = (value: unknown): string => {
  return parseProperty(value, "username")
}
